module.exports = __webpack_public_path__ + "static/media/free-form.21eb3eb0.svg";